import { useState } from 'react';
import styles from 'styles/modules/Checkbox.module.scss';

const Checkbox = ({
    name,
    label,
    register,
    initialValue,
    onChange,
    className,
    error,
    disabled = false,
}) => {
    const [checked, setChecked] = useState(initialValue);

    return (
        <div
            className={[styles.checkbox, className ? className : ''].join(' ')}
        >
            <input
                name={name}
                id={name}
                type="checkbox"
                disabled={disabled}
                defaultChecked={initialValue}
                checked={register ? undefined : checked}
                onChange={
                    register
                        ? undefined
                        : ({ target: { checked } }) => {
                              setChecked(checked);
                              onChange ? onChange() : null;
                          }
                }
                className={styles.input}
                ref={register ? register : undefined}
            />
            <label htmlFor={name} className={styles.label}>
                {label}
            </label>
            {error?.message && <p className={styles.error}>{error.message}</p>}
        </div>
    );
};

export default Checkbox;
